import axios from "axios";
import AuthService from "../login/auth.service";
import { comprobantes, cuentas, transferencias } from "../../components/generico/utils/UrlAPI";

class TransferCuentasTercerosService {
  async getCuentas(tipoCuenta) {
    var data = JSON.stringify({
      canal: "WEB",
      tipo: tipoCuenta,
      estado: null,
      modalidad: null,
      moneda: null,
      tipoCuenta: null
    });

    var config = {
      method: "post",
      url: cuentas + "socio-cuenta/transferencias",
      //url: "http://localhost:8080/socio-cuenta/transferencias",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data
    };

    return await axios(config);
  }

  async transferir(ctaDebito, ctaCredito, monto, transferenciaDatosRepetidos) {
    var data = JSON.stringify({
      cuentaDebito: ctaDebito,
      cuentaCredito: ctaCredito,
      importe: monto,
      canal: "WEB",
      tipoCuenta: "AH",
      plan: null,
      grupo: null,
      tipoTransferencia: "TT",
      pin: null,
      transferenciaDatosRepetidos
    });

    var config = {
      method: "post",
      url: transferencias + "transferencia",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      },
      data: data,
    };

    return await axios(config);
  }

  async descagarComponente(titulo, nroOperacion, cuentaTitular, tipo, moneda, cuentaDebito, cuentaCredito, importeDebito, importeCredito, titularCuentaDestino) {

    var _url = comprobantes + "comprobantes/v2/transferencias";

    var data = JSON.stringify({
      titulo: titulo,
      nroOperacion: nroOperacion,
      cuentaTitular: cuentaTitular,
      tipo: tipo,
      moneda: moneda,
      cuentaDebito: cuentaDebito,
      cuentaCredito: cuentaCredito,
      importeDebito: importeDebito,
      importeCredito: importeCredito,
      titularCuentaDestino: titularCuentaDestino,
    });


    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);

  }

  async validarCuenta(cuentaCredito) {

    var config = {
      method: "get",
      url: cuentas + "socio-cuenta/v2/nombre-titular/" + cuentaCredito,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }


  async getParametrosSimulador() {

    var config = {
      method: "get",
      url: cuentas + "simulador/parametros/",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };

    return await axios(config);
  }


  async getResultadosSimulador(idMoneda,plazos,monto) {
    
    var config = {
      method: "get",
      url: cuentas + "simulador/ahorros-disponibles?idMoneda=" + idMoneda + '&plazoMaximo='+ plazos + '&monto=' + monto,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken()
      }
    };
  
    return await axios(config);
  }
}






export default new TransferCuentasTercerosService();
